import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NadajPrzesylkeType,
  ScreenType,
  SposobNadaniaType,
} from 'src/app/enums/enums';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  ScreenType = ScreenType;
  NadajPrzesylkeType = NadajPrzesylkeType;
  SposobNadaniaType = SposobNadaniaType;

  constructor(private storeService: StoreService) {}

  showProgressBar(): boolean {
    if (
      this.storeService.getScreenType() === ScreenType.OPCJE_NADANIA ||
      this.storeService.getScreenType() === ScreenType.OPCJE_DORECZENIA ||
      this.storeService.getScreenType() === ScreenType.UTWORZ_PRZESYLKE
    ) {
      return true;
    }
    return false;
  }

  showSzczegolyPrzesylki(): boolean {
    if (
      this.storeService.getNadajPrzesylkeTyp() ===
      NadajPrzesylkeType.STWORZ_NOWA_PRZESYLKE
    ) {
      return true;
    }
    return false;
  }

  enableSzczegolyPrzesylki(): boolean {
    if (
      this.storeService.getScreenType() === ScreenType.UTWORZ_PRZESYLKE ||
      this.storeService.getScreenType() === ScreenType.OPCJE_DORECZENIA
    ) {
      return true;
    }
    return false;
  }

  showOpcjeNadania(): boolean {
    if (
      this.storeService.getNadajPrzesylkeTyp() ===
        NadajPrzesylkeType.STWORZ_NOWA_PRZESYLKE ||
      this.storeService.getNadajPrzesylkeTyp() ===
        NadajPrzesylkeType.POSIADAM_ETYKIETE
    ) {
      return true;
    }
    return false;
  }

  enableOpcjeNadania(): boolean {
    if (
      (this.storeService.getSposobNadaniaStepNumber() === 0 &&
        this.storeService.getNadajPrzesylkeTyp() ===
          NadajPrzesylkeType.POSIADAM_ETYKIETE) ||
      (this.storeService.getSposobNadaniaStepNumber() === 0 &&
        this.storeService.getNadajPrzesylkeTyp() ===
          NadajPrzesylkeType.STWORZ_NOWA_PRZESYLKE &&
        this.storeService.getScreenType() === ScreenType.OPCJE_NADANIA)
    ) {
      return true;
    }
    return false;
  }

  showWalidacjaDanych(): boolean {
    if (
      this.storeService.getSposobNadaniaTyp() ===
        SposobNadaniaType.ZAMOW_KURIERA ||
      this.storeService.getScreenType() === ScreenType.UTWORZ_PRZESYLKE ||
      this.storeService.getScreenType() === ScreenType.OPCJE_DORECZENIA
    ) {
      return true;
    }
    return false;
  }

  enableWalidacjaDanych(): boolean {
    if (this.storeService.getSposobNadaniaStepNumber() === 1) {
      return true;
    }
    return false;
  }

  showPotwierdzenie(): boolean {
    if (
      this.storeService.getSposobNadaniaTyp() ===
        SposobNadaniaType.ZAMOW_KURIERA ||
      this.storeService.getScreenType() === ScreenType.UTWORZ_PRZESYLKE ||
      this.storeService.getScreenType() === ScreenType.OPCJE_DORECZENIA
    ) {
      return true;
    }
    return false;
  }

  enablePotwierdzenie(): boolean {
    if (this.storeService.getSposobNadaniaStepNumber() === 2) {
      return true;
    }
    return false;
  }

  showSzczegolyNadania(): boolean {
    if (
      (this.storeService.getNadajPrzesylkeTyp() ===
        NadajPrzesylkeType.POSIADAM_ETYKIETE &&
        this.storeService.getSposobNadaniaTyp() ===
          SposobNadaniaType.NADAJ_W_PUNKCIE) ||
      (this.storeService.getNadajPrzesylkeTyp() ===
        NadajPrzesylkeType.STWORZ_NOWA_PRZESYLKE &&
        this.storeService.getScreenType() === ScreenType.OPCJE_NADANIA &&
        this.storeService.getSposobNadaniaTyp() ===
          SposobNadaniaType.NADAJ_W_PUNKCIE)
    ) {
      return true;
    }
    return false;
  }

  enableSzczegolyNadania(): boolean {
    if (this.storeService.getSposobNadaniaStepNumber() === 1) {
      return true;
    }
    return false;
  }
}
